import PrimaryButton from "components/buttons/primary-button";
import Typography from "components/typography";
import React from "react";
import styled from "styled-components";
import { Colors } from "utils/colors";
import { ReactComponent as Arrow } from "images/svg/arrowRight.svg";
import Img1 from "images/png/pitch-easy-img/music-contact.png";
import Img2 from "images/png/pitch-easy-img/epk-builder.png";
import Img3 from "images/png/pitch-easy-img/pr-guide.png";

const WhatsInside = () => {
  return (
    <Container>
      <Heading>
        <HeadingSvg>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="100%"
            height="100%"
            viewBox="0 0 41 40"
            fill="none"
          >
            <path
              d="M8.16101 1.44753C7.2657 1.44128 6.31805 1.54753 5.34226 1.75924L10.6649 20.3975C9.55555 19.9991 8.22898 19.9132 6.90789 20.1475C3.84773 20.6866 1.66179 22.7882 2.02351 24.8194C2.38601 26.8585 5.15945 28.0772 8.22117 27.5303C11.2743 26.9913 13.4618 24.8975 13.0946 22.8585C11.368 16.546 9.62586 10.1241 7.90789 3.77956C11.868 4.06003 13.579 6.24674 14.9852 8.49128C14.9462 3.62174 12.0399 1.47487 8.16101 1.44753ZM32.4305 3.84596C31.3446 3.85378 30.1805 4.04831 28.9852 4.41003L35.7899 22.5694C34.6493 22.2647 33.3212 22.2803 32.0165 22.6241C29.0165 23.4053 27.0009 25.671 27.5243 27.671C28.0477 29.6788 30.9149 30.6632 33.9149 29.8741C36.9227 29.0928 38.9305 26.8272 38.4071 24.8272C36.1727 18.671 33.9305 12.4132 31.704 6.21784C35.6727 6.17878 37.5555 8.22565 39.1415 10.3507C38.7352 5.77643 35.9852 3.81862 32.4305 3.84596ZM20.6884 12.7725L20.829 32.1553C19.868 31.4835 18.6102 31.0382 17.2665 30.9132C14.1884 30.6163 11.5087 32.046 11.3134 34.1163C11.118 36.171 13.4774 38.085 16.5555 38.3741C19.6571 38.6788 22.3134 37.2413 22.5165 35.1788C22.5321 28.6319 22.579 21.9835 22.618 15.4053C26.3602 16.7335 27.4305 19.296 28.1805 21.8428C29.7352 16.0538 26.0009 13.0694 20.6884 12.7725Z"
              fill="#FEB73D"
            />
          </svg>
        </HeadingSvg>
        <Typography m_size="4xl" size="3.6rem" weight="bold">
          What’s Inside Pitch Easy?
        </Typography>
      </Heading>
      <Typography
        align="center"
        size="2xl"
        color={Colors.grey600}
        mb="2.4"
        m_size="lg"
        m_mb="3.2"
      >
        A better chance for your music to be heard
      </Typography>
      <Grid>
        <GridItem>
          <Typography size="4rem" m_size="3xl" m_mb="1.6" weight="bold" mb="4">
            Music Contact Database
          </Typography>
          <Typography
            size="lg"
            m_mb="2.4"
            m_size="m"
            color={Colors.grey400}
            mb="4"
          >
            Gain exclusive access to a curated list of record labels, playlist
            curators, media outlets, and industry professionals ready to
            discover new talent.
          </Typography>
          <PrimaryButton
            onClick={() => {
              // navigate("/overview/promo-cards/create");
            }}
            text="Start Pitching"
            icon={<Arrow />}
            inset
            sparkle
            iconPosition="right"
            fitContent
            iconSize="2"
          />
        </GridItem>
        <GridItem>
          <GridImage src={Img1} alt="Music-contant" />
        </GridItem>
        <GridItem>
          <GridImage src={Img2} alt="EPK-builder" />
        </GridItem>
        <GridItem>
          <Typography size="4rem" m_size="3xl" m_mb="1.6" weight="bold" mb="4">
            EPK Builder
          </Typography>
          <Typography
            size="lg"
            m_mb="2.4"
            m_size="m"
            color={Colors.grey400}
            mb="4"
          >
            Create a professional, eye-catching Electronic Press Kit using our
            template. Showcase your bio, music, press photos, and achievements
            with an easy-to-share link.
          </Typography>
          <PrimaryButton
            onClick={() => {
              // navigate("/overview/promo-cards/create");
            }}
            text="Create Now"
            icon={<Arrow />}
            inset
            sparkle
            iconPosition="right"
            fitContent
            iconSize="2"
          />
        </GridItem>
        <GridItem>
          <Typography size="4rem" m_size="3xl" m_mb="1.6" weight="bold" mb="4">
            PR Guide & Strategy
          </Typography>
          <Typography
            size="lg"
            m_mb="2.4"
            m_size="m"
            color={Colors.grey400}
            mb="4"
          >
            Navigate the music industry with expert tips on pitching to blogs,
            securing interviews, and maximizing your music’s reach.
          </Typography>
          <PrimaryButton
            onClick={() => {
              // navigate("/overview/promo-cards/create");
            }}
            text="Try it Now"
            icon={<Arrow />}
            inset
            sparkle
            iconPosition="right"
            fitContent
            iconSize="2"
          />
        </GridItem>
        <GridItem>
          <GridImage src={Img3} alt="Pr-guide" />
        </GridItem>
      </Grid>
    </Container>
  );
};

export default WhatsInside;

const Container = styled.div`
  width: 100%;
  margin-bottom: 15rem;
  @media only screen and (max-width: 769px) {
    margin-bottom: 6.4rem;
  }
`;

const Heading = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  margin-bottom: 2rem;
`;
const HeadingSvg = styled.div`
  width: 4rem;
  @media only screen and (max-width: 769px) {
    width: 3.2rem;
  }
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: 35% 35%;
  padding: 0 4rem;
  align-items: center;
  justify-content: space-between;
  grid-row-gap: 2.4rem;
  @media only screen and (max-width: 769px) {
    padding: 0 2rem;
    grid-template-columns: 100%;
    & :nth-child(3) {
      order: 4;
    }
    & :nth-child(4) {
      order: 3;
    }
    & :nth-child(5) {
      order: 5;
    }
    & :nth-child(6) {
      order: 6;
    }
  }
`;

const GridItem = styled.div`
  width: 100%;
  @media only screen and (max-width: 769px) {
    display: flex;
    flex-direction: column;
  }
`;

const GridImage = styled.img`
  width: 50rem;
  @media only screen and (max-width: 769px) {
    width: 35rem;
    margin-left: auto;
    margin-right: auto;
  }
`;
